import { bindActionCreators } from 'redux';
import idx from 'idx';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { showBanner, hideBanner } from 'common/ducks/banner';
import { fetchAll as fetchFocusGroups } from 'focus_groups/ducks/view_state';
import { fetchAll as fetchPresentations } from 'presentations/ducks';
import { getWrapups } from 'project/ducks/wrapup';
import { getProjectIdFromUrl, isCollaborator, getProjectUrl, canViewAllEntries } from 'project/utils';
import { getProject } from 'project/ducks/project';
import partial from 'lodash/partial';
import HeaderTabs from 'project/components/header_tabs';
import { getSubcategorySlug } from 'common/ducks/categories';

export function mapStateToProps(state, { router }) {
  const project = getProject(state);
  const subcategory = getSubcategorySlug(state.categories, project.sub_category);
  const projectUrl = getProjectUrl(project, subcategory) || '';
  const userId = idx(state, _ => _.user.profile_data.id);
  const isCreative = idx(state, _ => _.user.profile_data.is_creative) || false;
  const groups = idx(state, _ => _.project.focusGroups.viewState.groups) || [];
  const presentations = idx(state, _ => _.project.presentations.presentations) || [];

  return {
    project,
    projectUrl,
    router,
    groups,
    presentations,
    wrapups: getWrapups(state),
    isCreative,
    isCollaborator: isCollaborator(project),
    isOwner: project.id && project.client === userId,
    isAuthenticated: !!userId,
    showEntries: canViewAllEntries(state)
  };
}

export function mapDispatchToProps(dispatch, { params }) {
  const projectId = getProjectIdFromUrl(params);

  return bindActionCreators({
    fetchFocusGroups: partial(fetchFocusGroups, projectId),
    fetchPresentations: partial(fetchPresentations, projectId),
    showBanner,
    hideBanner
  }, dispatch);
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(HeaderTabs));



// WEBPACK FOOTER //
// ./project/containers/header_tabs.jsx